export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">联系我们</h2>
        <p className="text-sm text-foreground-500 text-center mb-10">商务合作、内容投稿、意见反馈，欢迎随时联络</p>

        <div className="bg-background-100 rounded-lg border border-background-200/70 p-6 md:p-8">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 text-center">
            <div className="flex flex-col items-center gap-2">
              <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center">
                <i className="ri-mail-line text-accent-500 text-lg" />
              </div>
              <h3 className="text-sm font-medium text-foreground-800">商务合作</h3>
              <p className="text-xs text-foreground-500">business@uumanhua.com</p>
            </div>
            <div className="flex flex-col items-center gap-2">
              <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center">
                <i className="ri-edit-line text-primary-500 text-lg" />
              </div>
              <h3 className="text-sm font-medium text-foreground-800">内容投稿</h3>
              <p className="text-xs text-foreground-500">submit@uumanhua.com</p>
            </div>
            <div className="flex flex-col items-center gap-2">
              <div className="w-10 h-10 rounded-full bg-secondary-100 flex items-center justify-center">
                <i className="ri-customer-service-2-line text-secondary-500 text-lg" />
              </div>
              <h3 className="text-sm font-medium text-foreground-800">用户反馈</h3>
              <p className="text-xs text-foreground-500">feedback@uumanhua.com</p>
            </div>
          </div>

          <div className="mt-6 pt-6 border-t border-background-200/70 text-center">
            <p className="text-xs text-foreground-500">
              工作时间：周一至周五 9:00 - 18:00  ·  我们会在24小时内回复您的来信
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}